import React, { useState } from "react";
import { AppProvider } from "./AppContext";
import LoginPage       from "./LoginPage";
import LandingPage     from "./LandingPage";
import ParentDashboard from "./ParentDashboard";
import KioskCheckIn    from "./KioskCheckIn";

export default function App() {
  const [currentUser, setCurrentUser] = useState(() => {
    try { const s = sessionStorage.getItem("sixers_user"); return s ? JSON.parse(s) : null; }
    catch { return null; }
  });

  const handleLogin = (user) => {
    sessionStorage.setItem("sixers_user", JSON.stringify(user));
    setCurrentUser(user);
  };
  const handleLogout = () => {
    sessionStorage.removeItem("sixers_user");
    setCurrentUser(null);
  };

  const role     = currentUser?.user_role;
  const isParent = role === "Parent";
  const isKiosk  = role === "Kiosk";

  return (
    <AppProvider>
      {!currentUser
        ? <LoginPage onLogin={handleLogin} />
        : isParent
          ? <ParentDashboard currentUser={currentUser} onLogout={handleLogout} />
          : isKiosk
            ? <KioskCheckIn currentUser={currentUser} onLogout={handleLogout} />
            : <LandingPage
                currentUser={currentUser}
                currentUserId={currentUser.user_id}
                onLogout={handleLogout}
              />
      }
    </AppProvider>
  );
}
